import { TourOptions, Tour, ShowStepOptions, ModalStepOptions, TourNavigationEvent } from "./tour";
import { TourService } from "./tour.service";
import { BrowserUtilsService } from "../util/browserUtils.service";

export class DashboardTourOptions extends TourOptions {
    public userIsOfficeManager: boolean = false;

    constructor(
        userIsOfficeManager: boolean,
        tourService: TourService,
        browserUtilsService: BrowserUtilsService,
        onNavigateBackwardsCallback: (event: TourNavigationEvent) => Promise<void>,
        onNavigateForwardCallback: (event: TourNavigationEvent) => Promise<void>,
        onQuitCallback: (event: TourNavigationEvent) => Promise<void>,
        forceUndone: boolean = false) {
        super(tourService, browserUtilsService, onNavigateBackwardsCallback, onNavigateForwardCallback, onQuitCallback, forceUndone);
        this.userIsOfficeManager = userIsOfficeManager;
    }
}

export class DashboardTour extends Tour<DashboardTourOptions> {
    public static readonly WELCOME_STEP = "welcomeStep";
    public static readonly LAUNCHER_STEP = "launcherStep";
    public static readonly TALENT_APP_MENU_STEP = "talentAppMenuStep";
    public static readonly DASHBOARD_MENU_STEP = "dashboardMenuStep";
    public static readonly GENERIC_KPI_WELCOME_STEP = "genericKpiWelcomeStep";
    public static readonly GENERIC_KPI_STEP = "genericKpiStep";
    public static readonly GENERIC_KPI_UPDATE_STEP = "genericKpiUpdateStep";
    public static readonly NEW_FEATURES_WELCOME_STEP = "newFeaturesWelcomeStep";
    public static readonly SEND_SMS_STEP = "sendSmsStep";
    public static readonly ORDERS_TEA_PERM = "ordersTEAPermStep";
    public static readonly NEW_FEATURES_FAREWELL_STEP = "newFeaturesFarewellStep";
    public static readonly FAREWELL_STEP = "farewellStep";
    public static readonly OM_INTRO = "officeManagerIntroStep";
    public static readonly OM_HIGHLIGHT = "officeManagerHighlightStep";
    public static readonly OM_OUTRO = "officeManagerOutroStep";
    public static readonly CONTRACT_EXTENSION_STEP = "contractExtensionStep";
    public static readonly HANGOUTS_NEW_KPIS = "hangoutsKpisStep";
    public static readonly ABSENCES_KPI = "absencesKpiStep";

    public getClassName(): string {
        return "DashboardTour";
    }
    public getVersion(): number {
        return 13;
    }

    protected setup(options: DashboardTourOptions): void {
        if (options.tourService.isTourDone("DashboardComponent")) {
            options.tourService.remove("DashboardComponent");
            options.tourService.setTourState(this.getClassName(), true, 1);
        }

        let lastDoneVersion = options.forceUndone ? 0 : options.tourService.getTourDoneVersion(this.getClassName());

        if (lastDoneVersion == 0) {
            this.linkModal(DashboardTour.WELCOME_STEP, new ModalStepOptions(`<br/><p>Bienvenido a la nueva Home de FBI!!</p><br/>
                          <p>Desde aquí podrás tener acceso al nuevo dashboard y a las aplicaciones que utilizabas en FBI</p><br/>
                          <p>Comienza tu tour guiado para conocer mejor el Dashboard, ¡Adelante!</p><br/>`));

            this.linkShow(DashboardTour.LAUNCHER_STEP,
                new ShowStepOptions(document.querySelector('#launcher'),
                    '<br/><p>Ahora los iconos que tenías hasta la fecha en FBi, los tienes ordenados dependiendo a qué módulo pertenezca.</p>',
                    "right",
                    0));

            this.linkShow(DashboardTour.TALENT_APP_MENU_STEP,
                new ShowStepOptions('#appSelectorSelectorDialog',
                    '<br/><p>Aquí tienes los iconos relacionados con la gestión de candidatos y trabajadores.</p>',
                    'bottom',
                    -50));

            this.linkShow(DashboardTour.DASHBOARD_MENU_STEP,
                new ShowStepOptions('#dashboardMenu',
                    `<br/><p>Como ves hemos dividido el Dashboard en cuatro grandes bloques Call to Action, Clientes, Talento y Gestión & Control.<p>
                          <ul style="margin-left: 25px;">
                            <li type="disc">En Call to Action verás un resumen de los principales indicadores de Cliente, Talento y Gestión & Control.</li>
                            <li type="disc">En Clientes todo aquello que gestionas a nivel comercial.</li>
                            <li type="disc">En Talento lo que pertenece al Candidate Process, en este caso Buckets.</li>
                            <li type="disc">Gestión & Control, tienes los indicadores que te ayudarán en la gestión administrativa.</li>
                          </ul>`,
                    'bottom',
                    0));

            this.linkModal(DashboardTour.GENERIC_KPI_WELCOME_STEP,
                new ModalStepOptions(`<br/><p>Te vamos a enseñar cómo funciona cada KPI y como está distribuido el Dashboard.</p><br/>
                          <p>Si tienes dudas sobre algún KPI, puedes ir a la sección de ayuda. Además, si te posicionas encima del título te dará más información.</p><br/>`));

            this.linkShow(DashboardTour.GENERIC_KPI_STEP,
                new ShowStepOptions('#tourKpi',
                    `<br/><p>Verás que hay dos tipos de información:</p>
                          <ul style="margin-left: 25px;">
                            <li type="disc">Datos correspondientes a tus clientes <i class="icon icon-user"></i></li>
                            <li type="disc">Datos correspondientes a tu oficina <i class="icon icon-home"></i></li>
                          </ul><br/>
                          <p>Haciendo click sobre estos indicadores, podrás acceder en un instante a la información.</p>`,
                    'right'));

            this.linkShow(DashboardTour.GENERIC_KPI_UPDATE_STEP,
                new ShowStepOptions('#tourKpiOption',
                    `<br/><p>La información no se actualiza constantemente. ¿Qué debes hacer?  Pulsa en actualizar.</p>`,
                    'right'));

            this.linkModal(DashboardTour.SEND_SMS_STEP,
                new ModalStepOptions(`<br/><img src="./assets/tour/SMSTour.png" style="width:100%; height:auto;"></img><p>En los KPIs de Contratos pendientes de Firmar, dispones de una opción para poder enviar SMS a trabajadores con contratos pendientes en clientes de tu BBDD, utilízala.</p><br/>`));
        }

        let newFeatureSteps = [];

        if (lastDoneVersion > 0 && lastDoneVersion < 3) {
            newFeatureSteps.push(() => {
                this.linkModal(DashboardTour.SEND_SMS_STEP,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><img src="./assets/tour/SMSTour.png" style="width:100%; height:auto;"></img><p>En los KPIs de Contratos pendientes de Firmar, dispones de una opción para poder enviar SMS a trabajadores con contratos pendientes en clientes de tu BBDD, utilízala.</p><br/>`));
            });
        }

        if (lastDoneVersion > 0 && lastDoneVersion < 5) {
            newFeatureSteps.push(() => {
                this.linkModal(DashboardTour.ORDERS_TEA_PERM,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><img src="./assets/tour/PendingOrdersTEAPerm.png" style="width:100%; height:auto;"></img><p>Hemos <span style="font-weight:bold;">desglosado</span> el Kpi de pedidos pendiente por <span style="font-weight:bold;">selección</span> y <span style="font-weight:bold;">perm</span> para que te ayude en tu gestión diaria.</p><br/>`));
            });
        }

        if (lastDoneVersion > 0 && lastDoneVersion < 7 && options.userIsOfficeManager) {
            newFeatureSteps.push(() => {
                this.linkModal(DashboardTour.OM_INTRO,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><p>Ya tienes disponible el nuevo Dashboard para ti. Podrás visualizar la información que ven tus consultores.</p><br/>`));

                this.linkShow(DashboardTour.OM_HIGHLIGHT,
                    new ShowStepOptions("#impersonationSelector", `<br/><p>Aquí podrás elegir visión consultor y ver lo que visualizan cada uno de tus consultores en los kpis de persona.</p>`, 'left', 30));

                /*this.linkModal(DashboardTour.OM_OUTRO,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><p>Esperamos que esta mejora te ayude en la gestión de tu oficina.</p><br/>`));*/
            });
        }

        if (lastDoneVersion > 0 && lastDoneVersion < 8) {
            newFeatureSteps.push(() => {
                this.linkModal(DashboardTour.CONTRACT_EXTENSION_STEP,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><img src="./assets/tour/ContractExtensions.png" style="width:100%; height:auto;"></img><p>Novedad. Incluimos las prórrogas en la gestión y control de firma.</br>Esperamos que te ayude</p><br/>`));
            });
        }

        if (lastDoneVersion > 0 && lastDoneVersion < 9) {
            newFeatureSteps.push(() => {
                this.linkModal(DashboardTour.CONTRACT_EXTENSION_STEP,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><p>Desde hoy el indicador de clientes "no e-solutions" lo tienes en el apartado de clientes "digitalización".</p><br/>`));
            });
        }

        if (lastDoneVersion > 0 && lastDoneVersion < 13) {
            newFeatureSteps.push(() => {
                this.linkModal(DashboardTour.ABSENCES_KPI,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><p>Ya dispones de un nuevo kpi que te ayudará a controlar los absentismos.</br>Esperamos sea de ayuda para tu labor diaria.</p></br>`));
            });
        }

        ////Update steps
        if (newFeatureSteps.length > 0) {
            if (lastDoneVersion != 9 && lastDoneVersion != 10 && lastDoneVersion != 11) {
                this.linkModal(DashboardTour.NEW_FEATURES_WELCOME_STEP,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><p>Vamos a conocer las últimas novedades del Dashboard.</p><br/>`));
            }

            newFeatureSteps.forEach(x => x());

            if (lastDoneVersion != 9 && lastDoneVersion != 10 && lastDoneVersion != 11) {
                this.linkModal(DashboardTour.NEW_FEATURES_FAREWELL_STEP,
                    new ModalStepOptions(`<h1 style="font-weight: bold;">Novedades dashboard</h1><br/><p>Esperamos que estas novedades, te ayuden en tu gestión diaria.</p><br/>`));
            }
        }

        if (lastDoneVersion == 0) {
            this.linkModal(DashboardTour.FAREWELL_STEP,
                new ModalStepOptions(`<br/><p>Puedes acceder al Dashboard directamente desde tu móvil o tablet, solo tienes que abrir desde el Chrome la siguiente dirección:
                          <a href="https://fbi.randstad.es/">https://fbi.randstad.es/</a></p><br/>
                          <p>Esperamos que esta herramienta te sea de ayuda!!</p><br/>`));
        }
    }
}
